const ELEMENT_COLORS: Record<string, { bg: string; text: string }> = {
  N: { bg: '#dbeafe', text: '#1d4ed8' },
  P: { bg: '#fef3c7', text: '#92400e' },
  K: { bg: '#ede9fe', text: '#6d28d9' },
};

export function ParamIcon({ icon, size = 18 }: { icon: string; size?: number }) {
  const colors = ELEMENT_COLORS[icon];
  if (colors) {
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: size, height: size, borderRadius: 4,
        background: colors.bg, color: colors.text,
        fontSize: Math.round(size * 0.62), fontFamily: 'Georgia, serif', fontWeight: 700,
        flexShrink: 0, lineHeight: 1,
      }}>
        {icon}
      </span>
    );
  }
  return <span style={{ fontSize: size, lineHeight: 1 }}>{icon}</span>;
}
